import { render } from "./CustomfieldHistory.vue?vue&type=template&id=5508b40e"
import script from "./CustomfieldHistory.vue?vue&type=script&lang=js"
export * from "./CustomfieldHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__